export const labelFontFamily = 'Helvetica, Arial, Courier';
export const animationDuration = 3000;
export const animationEasing = 'easeOutQuart';
export const xLabelFormat = {
  autoSkip: false,
  fontColor: '#424242',
  fontFamily: labelFontFamily,
  fontSize: 14,
  lineHeight: 1.5,
  maxRotation: 0
};
export const xLabels = [
  1976,
  '',
  '',
  '',
  '',
  '',
  '',
  1983,
  '',
  '',
  '',
  '',
  '',
  '',
  1990,
  '',
  '',
  '',
  '',
  '',
  '',
  1997,
  '',
  '',
  '',
  '',
  '',
  '',
  2004,
  '',
  '',
  '',
  '',
  '',
  2011,
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  2019
];
